@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.options {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;

  @include for-desktop-only {
    grid-template-columns: repeat(3, 1fr);
  }
}
